/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="10"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Booking File Log</h1></div>
        <div class="header-sub-title">Get the booking file download logs</div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="1-2"/>
      <div class="content">
        <div>
          <div class="tool-bar row">
            <div class="col">
              <div class="icon-group right-float-element">
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="RH2Module"
                          v-model="listParam.RH2Module"/>
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="RH2ModuleID"
                          v-model="listParam.RH2ModuleID"/>
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="Operation Type"
                          v-model="listParam.OperationType"/>
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="Username"
                          v-model="listParam.UsernameLog"/>
                <el-date-picker
                    style="width: 260px"
                    v-model="dateValue"
                    type="daterange"
                    start-placeholder="Start Date"
                    popper-class="date-range-picker-popper"
                    value-format="yyyy-MM-dd"
                    format="dd/MM/yyyy"
                    @change="changeDates"
                    end-placeholder="End Date"
                    clearable
                />
              </div>
            </div>
          </div>
          <div class="content-scroll-x">
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:7%" class="long-text">ID</th>
                  <th style="width:20%" class="long-text">Messages</th>
                  <th style="width:12%" class="long-text">RH2Module</th>
                  <th style="width:13%" class="long-text">RH2ModuleID</th>
                  <th style="width:20%; vertical-align:middle" class="icon-col">Log Date</th>
                  <th style="width:13%; vertical-align:middle" class="icon-col">Operation Type</th>
                  <th style="width:15%; vertical-align:middle" class="icon-col">Username</th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="specialists.length > 5 ? 'content-scroll-y' : ''"> -->
            <div class="content-scroll-y">
              <table class="table">
                <tbody>
                <tr v-for="(log, index) in logs" :key="index" >
                  <td style="width:7%" class="long-text">
                    {{ log.ErrorLogID }}
                  </td>
                  <td style="width:20%" class="long-text">
                    <el-tooltip effect="dark" :content="log.Message">
                      <span>{{ log.Message }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:12%" class="long-text">
                    {{ log.RH2Module }}
                  </td>
                  <td style="width:13%" class="long-text">
                    <a v-if="log.RH2ModuleID" :href="log.RH2ModuleURL" target="_blank" style="text-decoration: underline">
                      {{ log.RH2ModuleID }}
                    </a>
                  </td>
                  <td style="width:20%;vertical-align:middle" class="icon-col">
                    {{ getTime(log.LogDate) }}
                  </td>
                  <td style="width:13%" class="long-text">
                    {{ log.OperationType }}
                  </td>
                  <td style="width:15%" class="long-text">
                    {{ decodeURIComponent(log.UsernameLog) }}
                  </td>
                </tr>
                <tr v-if="logs.length === 0">
                  <td colspan="9">No results to display.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import { debounce } from 'lodash';
import Header from '@/components/Header'

export default {
  name: 'AdminErrorLog',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    return {
      dateValue: [],
      hasError: false,
      logs: [],
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        FileName: '',
        OperationType: '',
        UsernameLog: '',
        RH2Module: '',
        RH2ModuleID: '',
        LogDateFrom: null,
        LogDateTo: null
      },
      successMessage: '',
    }
  },
  computed: {},
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    changeDates(v) {
      if (v) {
        this.listParam.LogDateFrom = v[0]
        this.listParam.LogDateTo = v[1]
      } else {
        this.listParam.LogDateFrom = null
        this.listParam.LogDateTo = null
      }
      this.selectPage(1)
    },
    getTime(item) {
      return moment(item).format('DD/MM/YYYY HH:mm:ss')
    },
    sortParam(v) {
      this.listParam.SortFlag = v
      this.selectPage(1)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    async loadData() {
      this.$store.dispatch("loading/setLoadComponent", true)
      let param = {}
      for (let i in this.listParam) {
        if (this.listParam[i] !== undefined && this.listParam[i] !== null && this.listParam[i] !== "") param[i] = this.listParam[i]
      }
      const {data, count} = await utilities.getErrorLogs(param)
      this.logs = data
      this.totalCount = count
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    addNewPersonCondition() {
      this.$refs.addPersonConditionModal.isEdit = false
      this.$refs.addPersonConditionModal.handleModal()
    },

    editCondition(index) {
      var item = this.personConditions[index]
      this.$refs.addPersonConditionModal.isEdit = true
      this.$refs.addPersonConditionModal.editItem(item)
      this.$refs.addPersonConditionModal.handleModal()

    }
  },
  async beforeMount() {
    await this.loadData()
  },
  mounted() {
  },
}
</script>
